import React from 'react'
import { createContext, useState } from "react";
import AuthContext from "./AuthContext";
import StatusContext from "./StatusContext";
import ClientContext from "./ClientContext";
import axios from "axios"

import { config } from '../config';
import { sortChats } from './StatusContext';


const BetterResponsesContext = createContext();

export default  BetterResponsesContext;

export const  BetterResponsesProvider = ((props) => {
    const [chatPrompt, setChatPrompt] = useState('');
    const [chatResponse, setChatResponse] = useState('');
    const [promptsandresponses, setPromptsAndResponses] = useState([]);
    const [chatName, setChatName] = useState('')
    const [chatNames, setChatNames] = useState([])
    const [confirmDelete, setConfirmDelete] = useState([])
    const [status, setStatus] = useState('');
   
    
    const [showdeletedialog, setShowDeleteDialog] = useState(false)
    const [showsavedialog, setShowSaveDialog] = useState(false)
    const [dialogboxtext, setDialogBoxText] = useState('')

    const [showProgressDialog, setShowProgressDialog] = useState(false)
    
    

    const {
        currentUser,
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
       
        changeLanguage,
        setIsLoading,
        isLoading,
        getChats,
        setShowLoginDialog,
        handleFocus,
        setWaitOnResponse,

        getAIProvider,
        getAIModel, 
        getAIName,
       
    } = React.useContext(StatusContext);

    const {
        availablecredits,
        updateCredits,
    } = React.useContext(ClientContext);


    const onClearChat = () => {
        setPromptsAndResponses([])
        setConfirmDelete([])
        setChatName('')
        setStatus('')
        setChatPrompt('')
    }

    const deleteChat = async (deletionChat) => {
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }
        let newchatNames = [];
        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/betterresponses/get", {currentUser}) 
            newchatNames =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }
        let filteredChats = newchatNames.filter(chat => chat.id !== deletionChat.id)
        let adjustedChats = sortChats(filteredChats)
        console.log("Adjusted Chats:", adjustedChats)
        
        var templates = JSON.stringify(adjustedChats)
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/betterresponses/save", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }
        setChatNames(adjustedChats);


        setIsLoading(false)

    }

    const displayChat = (displayedChat) => {

        onClearChat();

        setTimeout(() => {

        //fix prompts ids to match array indexes
        let index = 0;
           displayedChat.promptsandresponses.forEach((item) => {
            item.id = index;
            index++
        })

        setPromptsAndResponses(displayedChat.promptsandresponses)
        setChatName(displayedChat.chatname)

        var deletes = []
        displayedChat.promptsandresponses.forEach((item) => {
            let a = {
                id: item.id,
                state: false
            }
            deletes.push(a)
        })

        setConfirmDelete(deletes)
        },0)
    }

    const onDeletePrompt = (deletionChat) => {
        if (isLoading)
            return;
        console.log("BetterResponses: onDeletePrompt")
        let index = promptsandresponses.indexOf(deletionChat)

        let filteredChats = promptsandresponses.filter(chat => chat.id !== deletionChat.id)
        setPromptsAndResponses(filteredChats)

        let deleteconfirm = [...confirmDelete]

        deleteconfirm.splice(index, 1)
        setConfirmDelete(deleteconfirm)

    }

    const changeConfirmDelete = (prompt, flag) => {
        let a = [...confirmDelete]
        a.forEach((item) => {
            if (item.id === prompt.id)
                item.state = flag
        })

        setConfirmDelete(a)
    }

    const onSave = async () => {

        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (chatName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return
        }

        let exists = false;

        let newChats = [];
        let newChat = [];
        let newchatNames = [];

        setIsLoading(true);

        let chatstatus = await getChats('betterresponses');
       
        if (chatstatus.status !== 200)
        {
            setStatusNavbar("Unable to retrieve topics data.")
            setIsLoading(false);
            return;
        }

        //console.log('onSave:', chatstatus)

        newchatNames = chatstatus.chats;

        if ( chatstatus.status === 200)
        {
            newchatNames.forEach((chat) => {
                if (chat.chatname === chatName) {
                    let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                    if (!result)
                    {
                        setIsLoading(false);
                        return;
                    }
                    
                    chat.promptsandresponses = promptsandresponses;
                    newChat = chat;
                    exists = true;
                }
                newChats.push(JSON.parse(JSON.stringify(chat)));
            })
        }

        if (!exists) {
            let i = 0
            newchatNames === 0 ? i = 0 : i = newchatNames.length;
            newChat = {
                id: i,
                chatname: chatName,
                promptsandresponses: promptsandresponses,
            };
            newChats.push(newChat);
            
            //console.log("Save chats(before sort):", newChats)
            let adjustedChats = sortChats(newChats)
            newChats = [...adjustedChats]
            //console.log("Save chats(after sort):", newChats)
        }

        let templates = JSON.stringify(newChats)
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/betterresponses/save", { currentUser, templates }, {
                withCredentials: true
            })
        }
        catch (err) {
            setIsLoading(false);
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            return
        }

        setChatNames(newChats)
        setIsLoading(false);
       
    }

    
    const onSubmitChat = () => {
        console.log('OnSubmitChat:', chatPrompt)
        let text = ''
        SendRequest(chatPrompt, text, false)
    }

    const onResubmitChat = (prompt) => {
        console.log("onResubmitQuestion:", prompt)
        let text = ''
        SendRequest(prompt.prompt, text, false)
    }

   

    async function SendRequest(request, task, combinerequestandtask) {
       
        setStatus('')
     
        if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }

        if ( availablecredits === 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }
       
        if (request.length === 0) {
            setStatus(changeLanguage('status', 'promptempty'))
            return;
        }

        setShowProgressDialog(true)
        let i = 0;
        if (promptsandresponses.length) {
            i = promptsandresponses[promptsandresponses.length - 1].id + 1
        }

        let r = {
            id: i,
            prompt: request,
            response: "",
            aiprovider: "ChatGPT",
            aimodel: "gpt-5.6-luna",
            ainame: 'gpt-5.6-luna',
        }

        setPromptsAndResponses([...promptsandresponses, r])

        setWaitOnResponse(changeLanguage('betterresponses', 'waitonresponse_1'))

        if (promptsandresponses.length > 0)
        {
            handleFocus()
        }

        if (confirmDelete.length <= promptsandresponses.length) {
            let a = {
                id: i,
                state: false
            }
            setConfirmDelete([...confirmDelete, a])
        }
        let rqst = task + request

        setChatPrompt('')

        console.log("Promptsandresponses:", promptsandresponses)
      

        let req = {
            user:currentUser,
            request: rqst,
            temperature: temperature,
            aiprovider: "ChatGPT",
            aimodel: 'gpt-5.6-luna',
        }

        setIsLoading(true)

        //First request
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })
          

            let server_response = JSON.parse(res.data);

            if (promptsandresponses.length) {
                i = promptsandresponses[promptsandresponses.length - 1].id + 1
            } else i = 0
            r = {
                id: i,
                prompt: request,
                response: server_response.data,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }

            //setPromptsAndResponses([...promptsandresponses, r])
            //ScrollResponse()
            //handleFocus()
            setWaitOnResponse(changeLanguage('betterresponses', 'waitonresponse_2'))
            updateCredits(server_response.tokens)
           

        } catch (err) {
          
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
            setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
            setWaitOnResponse('')
            setShowProgressDialog(false)
            setIsLoading(false)
            return
        }
       
   //Second request
   rqst = "The topic is: " + request + " \n"
   rqst += "If this first draft needs  more information add as needed. Please, provide just a direct response without your comments. This is the first draft: "
   rqst += r.response

   req = {
    user:currentUser,
    request: rqst,
    temperature: temperature,
    aiprovider: "ChatGPT",
    aimodel: 'gpt-5.6-luna',
}

    try {
        const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
            withCredentials: true
        })
      

        let server_response = JSON.parse(res.data);

        if (promptsandresponses.length) {
            i = promptsandresponses[promptsandresponses.length - 1].id + 1
        } else i = 0
        r = {
            id: i,
            prompt: request,
            response: server_response.data,
            aiprovider: "Gemini",
            aimodel: "gemini-2.5-flash",
            ainame: 'gemini-2.5-flash',
        }

        //setPromptsAndResponses([...promptsandresponses, r])
        //ScrollResponse()
        //handleFocus()
      
        setWaitOnResponse(changeLanguage('betterresponses', 'waitonresponse_3'))
        updateCredits(server_response.tokens)
       

    } catch (err) {
      
        console.log("Error:", err)
        setStatus(`Error: ${checkServerCode(err.response.data)}`)
        setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
        setIsLoading(false)
        return
    }

    //Third request
   rqst = "The topic is: " + request + " \n"
   rqst += "If this first draft needs  more information add as needed. Please, provide just a direct response without your comments. This is the first draft: "
   rqst += r.response

   req = {
    user:currentUser,
    request: rqst,
    temperature: temperature,
    aiprovider: "Alibaba",
    aimodel: 'qwen-plus',
}

    try {
        const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
            withCredentials: true
        })
      

        let server_response = JSON.parse(res.data);

        if (promptsandresponses.length) {
            i = promptsandresponses[promptsandresponses.length - 1].id + 1
        } else i = 0
        r = {
            id: i,
            prompt: request,
            response: server_response.data,
            aiprovider: "Alibaba",
            aimodel: "qwen-plus",
            ainame: 'qwen-plus',
        }

        setPromptsAndResponses([...promptsandresponses, r])
        setWaitOnResponse('')
        updateCredits(server_response.tokens)
       

    } catch (err) {
      
        console.log("Error:", err)
        setStatus(`Error: ${checkServerCode(err.response.data)}`)
        setPromptsAndResponses(promptsandresponses.filter((chat) => { return chat.response !== "" }))
        setWaitOnResponse('')
    }
    setIsLoading(false)
    setShowProgressDialog(false)
   
}

    return < BetterResponsesContext.Provider value={{
        chatPrompt,
        setChatPrompt,
        chatResponse,
        setChatResponse,
        promptsandresponses,
        chatName,
        chatNames,
        setChatName,
        setChatNames,
        onSubmitChat,

        onClearChat,
        onSave,
        deleteChat,
        displayChat,
        onDeletePrompt,
        changeConfirmDelete,
        confirmDelete,
        
        status,
        setStatus,
    
        showdeletedialog, 
        setShowDeleteDialog,
        showsavedialog, 
        setShowSaveDialog,
        setDialogBoxText,
        dialogboxtext,

    
        onResubmitChat,

        showProgressDialog, 
        setShowProgressDialog,

     
    }}>
        {props.children}
    </ BetterResponsesContext.Provider>
})